var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30176 16.8749H4.55176C4.386 16.8749 4.22703 16.8091 4.10982 16.6918C3.99261 16.5746 3.92676 16.4157 3.92676 16.2499V12.7588C3.92676 12.6767 3.94292 12.5954 3.97433 12.5196C4.00574 12.4438 4.05178 12.3749 4.10982 12.3168L13.4848 2.94185C13.602 2.82464 13.761 2.75879 13.9268 2.75879C14.0925 2.75879 14.2515 2.82464 14.3687 2.94185L17.8598 6.43296C17.977 6.55017 18.0429 6.70915 18.0429 6.87491C18.0429 7.04067 17.977 7.19964 17.8598 7.31685L8.30176 16.8749Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4268 5L15.8018 9.375",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.9684d6b01c98bc21c3dfc45b390a7688.svg";
export { ForwardRef as ReactComponent };